module.exports = __webpack_public_path__ + "img/img7.8dfba51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img7.png
// module id = 378
// module chunks = 0